import PropTypes from 'prop-types';
import React, { Component } from 'react';

class ButtonTabs extends Component {
  setActive = (e) => {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onChange(e.target.value);
  };

  render() {
    const { activeTab, disabledTab } = this.props;
    return (
      <div className="button-tabs">
        {/* eslint-disable-next-line react/destructuring-assignment */}
        {this.props.tabs.length > 0 && this.props.tabs.map((tab, index) => (
          // eslint-disable-next-line react/button-has-type
          <button
            className={`button-tabs__tab ${tab.value === activeTab ? 'active' : ''}`}
            key={tab.value}
            onClick={this.setActive}
            tabIndex={index}
            disabled={disabledTab}
            value={tab.value}
          >
            {tab.label}
          </button>
        ))}
      </div>
    );
  }
}

ButtonTabs.defaultProps = {
  tabs: [],
};

ButtonTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  onChange: PropTypes.func,
  activeTab: PropTypes.string,
  disabledTab: PropTypes.bool,
};

export default ButtonTabs;
